<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Our Features</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/our-features" class="h5 text-white">Our Features</a>
        </div>
    </div>
</div>

<!-- Features Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Why Choose Us</h5>
            <h1 class="mb-0">We Help Brands Stand Out with Stunning Design & Strategy</h1>
        </div>
        <div class="row g-5">
           <!-- LEFT FEATURES -->
            <div class="col-lg-4">
                <div class="row g-5">
                    <div class="col-12" *ngFor="let feature of leftFeatures">
                        <div class="bg-primary border-radius d-flex align-items-center justify-content-center mb-3"
                            style="width: 60px; height: 60px;">
                            <i class="bi text-white fs-4" [ngClass]="feature.icon"></i>
                        </div>
                        <h4>{{feature.title}}</h4>
                        <p class="mb-0">{{feature.desc}}</p>
                    </div>
                </div>
            </div>
            <!-- CENTER IMAGE -->
            <div class="col-lg-4" style="min-height: 350px;">
                <div class="position-relative h-100">
                    <img class="position-absolute w-100 h-100 border-radius wow zoomIn" src="assets/images/feature.jpg"
                        style="object-fit: cover;" alt="feature-img">
                </div>
            </div>
            <!-- RIGHT FEATURES -->
            <div class="col-lg-4">
                <div class="row g-5">
                    <div class="col-12" *ngFor="let feature of rightFeatures">
                        <div class="bg-primary border-radius d-flex align-items-center justify-content-center mb-3"
                            style="width: 60px; height: 60px;">
                            <i class="bi text-white fs-4" [ngClass]="feature.icon"></i>
                        </div>
                        <h4>{{feature.title}}</h4>
                        <p class="mb-0">{{feature.desc}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Features Start -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->